import React, { useState } from 'react'

import CommentList from 'components/containers/comment/list/CommentList'
import AnimatedWindow from 'components/containers/common/AnimatedWindow'
import AnimatedWindowHeader from 'components/presenters/header/AnimatedWindowHeader'

export default function CreateCommentReplyModal({
  visible,
  setVisible,
  type,
  targetNo,
  commentNo,
  onUpdateComment,
  onDeleteComment,
  onReplyInserted,
  onReplyDeleted,
  onReplyUpdated,
}) {
  return (
    <>
      <AnimatedWindow windowOn={visible} setWindowOn={setVisible}>
        <AnimatedWindowHeader
          title={'답글 달기'}
          onBackBtn={() => {
            window.history.back()
            setVisible(false)
          }}
        />
        <div
          style={{
            overflowY: 'scroll',
            paddingLeft: 'calc(100vw*(17/375))',
            paddingRight: 'calc(100vw*(21/375))',
          }}
        >
          {visible && (
            <CommentList
              listType={'reply_list'}
              type={type}
              targetNo={targetNo}
              commentNo={commentNo}
              replyInitCnt={5}
              replyCnt={5}
              limit={1}
              disableCreateReply={true}
              enableCreateReplyForm={true}
              onUpdateComment={(updatedItem) => {
                if (onUpdateComment) onUpdateComment(updatedItem)
              }}
              onDeleteComment={(deletedItem) => {
                if (onDeleteComment) onDeleteComment(deletedItem)
              }}
              onReplyInserted={(insertedItem) => {
                if (onReplyInserted) onReplyInserted(insertedItem)
              }}
              onReplyDeleted={(deletedItem) => {
                if (onReplyDeleted) onReplyDeleted(deletedItem)
              }}
              onReplyUpdated={(updatedItem) => {
                if (onReplyUpdated) onReplyUpdated(updatedItem)
              }}
            />
          )}
        </div>
      </AnimatedWindow>
    </>
  )
}
